var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.deviceType == 'desktop')?_c('home-desktop',{attrs:{"message":_vm.message},on:{"login":_vm.login}}):_c('home-mobile',{attrs:{"message":_vm.message},on:{"login":_vm.login}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }